export default {
	terms: "Términos y condiciones",
	and: "Y",
	actions: {
		Submit: "Enviar",
		BackToLogin: "Volver al inicio de sesión",
		Register: "Registrarse",
		Logout: "Cerrar sesión",
		Update: "Actualizar",
		Verify: "Verificar",
		connect: "Conectar",
		Taptochange: "Toca para cambiar"
	},
	rules: {
		isRequired: "Requerido",
		require: "{0} es requerido",
		valid: "{0} no es un {0} válido",
		cannotContainBlankStrings: "{0} no puede contener cadenas en blanco"
	},
	options: {
		gender: ["Masculino", "Femenino"]
	}
};
